import { render, staticRenderFns } from "./IEModal.vue?vue&type=template&id=c6001b6e&"
import script from "./IEModal.vue?vue&type=script&lang=js&"
export * from "./IEModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports